module.exports = __webpack_public_path__ + "static/media/histogram-chart.5bed746d.png";